import React, { useState } from "react";
import { Autocomplete } from "@material-ui/lab";
import { TextField } from "@material-ui/core";
import { IconButton } from "@material-ui/core";
import SearchIcon from '@mui/icons-material/Search';
import { useHistory } from "react-router-dom";
import useGlobal from "../../store";
import { searchGraph } from "../../services/MetadataService";

 const SearchBox = () => {
	const [options, setOptions] = useState([]);
	const [searchTerm, setSearchTerm] = useState();

	let history = useHistory();
	const [globalStatus, globalActions] = useGlobal();
	const onChangeHandle = (value) => {
		searchGraph(value, false).then((response) => {
			setSearchTerm(value)
			setOptions(response)
		}).catch((error) => {
			console.log(error)
		})
	};

	return (
		<div className="search-box">
				<Autocomplete
						disablePortal
						id="searchable"
						options={options || []}
						getOptionLabel={option => option.name}
						style = {{width: 300}}
						fullWidth = {false}
						renderOption = { (props, option, state) => {
							return <div className="search-option">
								<div className="search-option-type">{props.context}</div>
								<div className="search-option-name">{props.name}</div>
								</div>
						}}
						renderInput={(params) => 
							<TextField {...params} 
								label="Location, Space, or Equipment" 
								variant="outlined" 
								onChange={ev => {
									// dont fire API if the user delete or not entered anything
									if (ev.target.value !== "" || ev.target.value !== null) {
									  onChangeHandle(ev.target.value);
									}
									
								  }}/>
						}
						onChange = {(event, value, reason) => {
							console.log(value)
							if (value.context === "site") {
								globalActions.setSite(value)
								history.push("/locations/" + value.id)
							} else if (value.context === "building") {
								globalActions.setSite(value)
								history.push("/buildings/" + value.id)
							} else if (value.context === "space") {
								globalActions.setSite(value)
								history.push("/spaces/" + value.id)
							} else if (value.context === "equipment") {
								globalActions.setSite(value)
								history.push("/equipment/" + value.id)
							}
						}
					}
				/>
				<div className="search-icon">
					<IconButton 
						variant="contained" 
						color="primary"
						aria-label="See search results page"

						onClick={() => {
							history.push("/search?q=" + searchTerm)
					}}>
						<SearchIcon />
					</IconButton> 
				</div>

		</div>
	)
}

export default SearchBox;